module.exports = __webpack_public_path__ + "img/tap-menu-menu-designs-min.c6871d07.png";